import styled, { css } from "styled-components";
import getBorderColor from "../../../../utils/getBorderColor";
import getBorderRadius from "../../../../utils/getBorderRadius";
import getBoxShadow from "../../../../utils/getBoxShadow";
import getColor from "../../../../utils/getColor";
import space from "../../../../utils/space";
import unit from "../../../../utils/unit";
import TextAtm from "../../../atoms/TextAtm";
import FlexContainerOrg from "../../../organisms/FlexContainerOrg";
export var StyledMobileProductBoxMol = styled.div.withConfig({
  componentId: "sc-emo9wp-0"
})(function (_ref) {
  var $hasPromotionText = _ref.$hasPromotionText,
    $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["position:relative;border:", " solid ", ";box-shadow:", ";padding-top:", ";border-radius:", ";", ""], unit(1), getBorderColor(theme, $onColor, "low"), getBoxShadow(theme, "nano"), space(3), getBorderRadius(theme, "mlarge"), $hasPromotionText && css(["padding-top:", ";"], space(4)));
});
export var MobilePromotionText = styled(TextAtm).withConfig({
  componentId: "sc-emo9wp-1"
})(function (_ref2) {
  var theme = _ref2.theme;
  return css(["position:absolute;right:0;top:0;background:", ";padding:", " ", ";border-radius:0 ", " 0 ", ";"], getColor(theme, "primary"), space(0.5), space(2), getBorderRadius(theme, "mlarge"), getBorderRadius(theme, "mlarge"));
});
export var MobileItemsBox = styled.div.withConfig({
  componentId: "sc-emo9wp-2"
})(["display:grid;grid-template-columns:1fr 3fr;gap:", ";"], space(1.5));
export var MobilePriceBox = styled(FlexContainerOrg).withConfig({
  componentId: "sc-emo9wp-3"
})(function (_ref3) {
  var $onColor = _ref3.$onColor,
    theme = _ref3.theme;
  return css(["width:100%;text-align:center;margin-top:", ";padding-top:", ";border-top:", " solid ", ";"], space(2), space(2), unit(1), getBorderColor(theme, $onColor, "low"));
});
export var MobileRenewalPrice = styled.div.withConfig({
  componentId: "sc-emo9wp-4"
})(function (_ref4) {
  var theme = _ref4.theme;
  return css(["text-align:center;margin-top:", ";background-color:", ";border-radius:0 0 ", " ", ";padding:", " ", ";"], space(2), getColor(theme, "background"), getBorderRadius(theme, "mlarge"), getBorderRadius(theme, "mlarge"), space(1.5), space(3));
});